/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as dashboardRouteRouteImport } from './routes/(dashboard)/route'
import { Route as dashboardIndexRouteImport } from './routes/(dashboard)/index'
import { Route as OnboardingWelcomeRouteImport } from './routes/onboarding/welcome'
import { Route as OnboardingInviteTeamRouteImport } from './routes/onboarding/invite-team'
import { Route as OnboardingCreateOrganizationRouteImport } from './routes/onboarding/create-organization'
import { Route as OnboardingCreateBranchRouteImport } from './routes/onboarding/create-branch'
import { Route as OnboardingConsentRouteImport } from './routes/onboarding/consent'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as dashboardSuppliersRouteImport } from './routes/(dashboard)/suppliers'
import { Route as dashboardSalesRouteImport } from './routes/(dashboard)/sales'
import { Route as dashboardReportsRouteImport } from './routes/(dashboard)/reports'
import { Route as dashboardPromotionsRouteImport } from './routes/(dashboard)/promotions'
import { Route as dashboardProductsRouteImport } from './routes/(dashboard)/products'
import { Route as dashboardPrescribersRouteImport } from './routes/(dashboard)/prescribers'
import { Route as dashboardCustomersRouteImport } from './routes/(dashboard)/customers'
import { Route as dashboardCategoriesRouteImport } from './routes/(dashboard)/categories'
import { Route as dashboardAnalyticsRouteImport } from './routes/(dashboard)/analytics'
import { Route as dashboardSettingsIndexRouteImport } from './routes/(dashboard)/settings/index'
import { Route as dashboardBranchIndexRouteImport } from './routes/(dashboard)/branch/index'
import { Route as dashboardAccountIndexRouteImport } from './routes/(dashboard)/account/index'
import { Route as dashboardSettingsRolesRouteImport } from './routes/(dashboard)/settings/roles'
import { Route as dashboardSettingsPrinterRouteImport } from './routes/(dashboard)/settings/printer'
import { Route as dashboardSettingsOrganizationRouteImport } from './routes/(dashboard)/settings/organization'
import { Route as dashboardSettingsMembersRouteImport } from './routes/(dashboard)/settings/members'
import { Route as dashboardSettingsIntegrationsRouteImport } from './routes/(dashboard)/settings/integrations'
import { Route as dashboardSettingsBranchesRouteImport } from './routes/(dashboard)/settings/branches'
import { Route as dashboardSettingsBillingRouteImport } from './routes/(dashboard)/settings/billing'
import { Route as dashboardSettingsApiRouteImport } from './routes/(dashboard)/settings/api'
import { Route as dashboardBranchStaffRouteImport } from './routes/(dashboard)/branch/staff'
import { Route as dashboardBranchRoomsRouteImport } from './routes/(dashboard)/branch/rooms'
import { Route as dashboardBranchPrescriptionsRouteImport } from './routes/(dashboard)/branch/prescriptions'
import { Route as dashboardBranchInventoryRouteImport } from './routes/(dashboard)/branch/inventory'
import { Route as dashboardBranchCashDrawersRouteImport } from './routes/(dashboard)/branch/cash-drawers'
import { Route as dashboardAccountSecurityRouteImport } from './routes/(dashboard)/account/security'
import { Route as dashboardBranchSettingsIndexRouteImport } from './routes/(dashboard)/branch/settings/index'
import { Route as dashboardBranchSettingsTaxRouteImport } from './routes/(dashboard)/branch/settings/tax'
import { Route as dashboardBranchSettingsHoursRouteImport } from './routes/(dashboard)/branch/settings/hours'

const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardRouteRoute = dashboardRouteRouteImport.update({
  id: '/(dashboard)',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardIndexRoute = dashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const OnboardingWelcomeRoute = OnboardingWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingInviteTeamRoute = OnboardingInviteTeamRouteImport.update({
  id: '/invite-team',
  path: '/invite-team',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingCreateOrganizationRoute =
  OnboardingCreateOrganizationRouteImport.update({
    id: '/create-organization',
    path: '/create-organization',
    getParentRoute: () => OnboardingRouteRoute,
  } as any)
const OnboardingCreateBranchRoute = OnboardingCreateBranchRouteImport.update({
  id: '/create-branch',
  path: '/create-branch',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingConsentRoute = OnboardingConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardSuppliersRoute = dashboardSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardSalesRoute = dashboardSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardReportsRoute = dashboardReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardPromotionsRoute = dashboardPromotionsRouteImport.update({
  id: '/promotions',
  path: '/promotions',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardProductsRoute = dashboardProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardPrescribersRoute = dashboardPrescribersRouteImport.update({
  id: '/prescribers',
  path: '/prescribers',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardCustomersRoute = dashboardCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardCategoriesRoute = dashboardCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardAnalyticsRoute = dashboardAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardSettingsIndexRoute = dashboardSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardBranchIndexRoute = dashboardBranchIndexRouteImport.update({
  id: '/branch/',
  path: '/branch/',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardAccountIndexRoute = dashboardAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardSettingsRolesRoute = dashboardSettingsRolesRouteImport.update({
  id: '/settings/roles',
  path: '/settings/roles',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardSettingsPrinterRoute =
  dashboardSettingsPrinterRouteImport.update({
    id: '/settings/printer',
    path: '/settings/printer',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardSettingsOrganizationRoute =
  dashboardSettingsOrganizationRouteImport.update({
    id: '/settings/organization',
    path: '/settings/organization',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardSettingsMembersRoute =
  dashboardSettingsMembersRouteImport.update({
    id: '/settings/members',
    path: '/settings/members',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardSettingsIntegrationsRoute =
  dashboardSettingsIntegrationsRouteImport.update({
    id: '/settings/integrations',
    path: '/settings/integrations',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardSettingsBranchesRoute =
  dashboardSettingsBranchesRouteImport.update({
    id: '/settings/branches',
    path: '/settings/branches',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardSettingsBillingRoute =
  dashboardSettingsBillingRouteImport.update({
    id: '/settings/billing',
    path: '/settings/billing',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardSettingsApiRoute = dashboardSettingsApiRouteImport.update({
  id: '/settings/api',
  path: '/settings/api',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardBranchStaffRoute = dashboardBranchStaffRouteImport.update({
  id: '/branch/staff',
  path: '/branch/staff',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardBranchRoomsRoute = dashboardBranchRoomsRouteImport.update({
  id: '/branch/rooms',
  path: '/branch/rooms',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const dashboardBranchPrescriptionsRoute =
  dashboardBranchPrescriptionsRouteImport.update({
    id: '/branch/prescriptions',
    path: '/branch/prescriptions',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardBranchInventoryRoute =
  dashboardBranchInventoryRouteImport.update({
    id: '/branch/inventory',
    path: '/branch/inventory',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardBranchCashDrawersRoute =
  dashboardBranchCashDrawersRouteImport.update({
    id: '/branch/cash-drawers',
    path: '/branch/cash-drawers',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardAccountSecurityRoute =
  dashboardAccountSecurityRouteImport.update({
    id: '/account/security',
    path: '/account/security',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardBranchSettingsIndexRoute =
  dashboardBranchSettingsIndexRouteImport.update({
    id: '/branch/settings/',
    path: '/branch/settings/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardBranchSettingsTaxRoute =
  dashboardBranchSettingsTaxRouteImport.update({
    id: '/branch/settings/tax',
    path: '/branch/settings/tax',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardBranchSettingsHoursRoute =
  dashboardBranchSettingsHoursRouteImport.update({
    id: '/branch/settings/hours',
    path: '/branch/settings/hours',
    getParentRoute: () => dashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/callback': typeof CallbackRoute
  '/privacy': typeof PrivacyRoute
  '/analytics': typeof dashboardAnalyticsRoute
  '/categories': typeof dashboardCategoriesRoute
  '/customers': typeof dashboardCustomersRoute
  '/prescribers': typeof dashboardPrescribersRoute
  '/products': typeof dashboardProductsRoute
  '/promotions': typeof dashboardPromotionsRoute
  '/reports': typeof dashboardReportsRoute
  '/sales': typeof dashboardSalesRoute
  '/suppliers': typeof dashboardSuppliersRoute
  '/invite/$token': typeof InviteTokenRoute
  '/onboarding/consent': typeof OnboardingConsentRoute
  '/onboarding/create-branch': typeof OnboardingCreateBranchRoute
  '/onboarding/create-organization': typeof OnboardingCreateOrganizationRoute
  '/onboarding/invite-team': typeof OnboardingInviteTeamRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/': typeof dashboardIndexRoute
  '/account/security': typeof dashboardAccountSecurityRoute
  '/branch/cash-drawers': typeof dashboardBranchCashDrawersRoute
  '/branch/inventory': typeof dashboardBranchInventoryRoute
  '/branch/prescriptions': typeof dashboardBranchPrescriptionsRoute
  '/branch/rooms': typeof dashboardBranchRoomsRoute
  '/branch/staff': typeof dashboardBranchStaffRoute
  '/settings/api': typeof dashboardSettingsApiRoute
  '/settings/billing': typeof dashboardSettingsBillingRoute
  '/settings/branches': typeof dashboardSettingsBranchesRoute
  '/settings/integrations': typeof dashboardSettingsIntegrationsRoute
  '/settings/members': typeof dashboardSettingsMembersRoute
  '/settings/organization': typeof dashboardSettingsOrganizationRoute
  '/settings/printer': typeof dashboardSettingsPrinterRoute
  '/settings/roles': typeof dashboardSettingsRolesRoute
  '/account/': typeof dashboardAccountIndexRoute
  '/branch/': typeof dashboardBranchIndexRoute
  '/settings/': typeof dashboardSettingsIndexRoute
  '/branch/settings/hours': typeof dashboardBranchSettingsHoursRoute
  '/branch/settings/tax': typeof dashboardBranchSettingsTaxRoute
  '/branch/settings/': typeof dashboardBranchSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/callback': typeof CallbackRoute
  '/privacy': typeof PrivacyRoute
  '/analytics': typeof dashboardAnalyticsRoute
  '/categories': typeof dashboardCategoriesRoute
  '/customers': typeof dashboardCustomersRoute
  '/prescribers': typeof dashboardPrescribersRoute
  '/products': typeof dashboardProductsRoute
  '/promotions': typeof dashboardPromotionsRoute
  '/reports': typeof dashboardReportsRoute
  '/sales': typeof dashboardSalesRoute
  '/suppliers': typeof dashboardSuppliersRoute
  '/invite/$token': typeof InviteTokenRoute
  '/onboarding/consent': typeof OnboardingConsentRoute
  '/onboarding/create-branch': typeof OnboardingCreateBranchRoute
  '/onboarding/create-organization': typeof OnboardingCreateOrganizationRoute
  '/onboarding/invite-team': typeof OnboardingInviteTeamRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/': typeof dashboardIndexRoute
  '/account/security': typeof dashboardAccountSecurityRoute
  '/branch/cash-drawers': typeof dashboardBranchCashDrawersRoute
  '/branch/inventory': typeof dashboardBranchInventoryRoute
  '/branch/prescriptions': typeof dashboardBranchPrescriptionsRoute
  '/branch/rooms': typeof dashboardBranchRoomsRoute
  '/branch/staff': typeof dashboardBranchStaffRoute
  '/settings/api': typeof dashboardSettingsApiRoute
  '/settings/billing': typeof dashboardSettingsBillingRoute
  '/settings/branches': typeof dashboardSettingsBranchesRoute
  '/settings/integrations': typeof dashboardSettingsIntegrationsRoute
  '/settings/members': typeof dashboardSettingsMembersRoute
  '/settings/organization': typeof dashboardSettingsOrganizationRoute
  '/settings/printer': typeof dashboardSettingsPrinterRoute
  '/settings/roles': typeof dashboardSettingsRolesRoute
  '/account': typeof dashboardAccountIndexRoute
  '/branch': typeof dashboardBranchIndexRoute
  '/settings': typeof dashboardSettingsIndexRoute
  '/branch/settings/hours': typeof dashboardBranchSettingsHoursRoute
  '/branch/settings/tax': typeof dashboardBranchSettingsTaxRoute
  '/branch/settings': typeof dashboardBranchSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(dashboard)': typeof dashboardRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/callback': typeof CallbackRoute
  '/privacy': typeof PrivacyRoute
  '/(dashboard)/analytics': typeof dashboardAnalyticsRoute
  '/(dashboard)/categories': typeof dashboardCategoriesRoute
  '/(dashboard)/customers': typeof dashboardCustomersRoute
  '/(dashboard)/prescribers': typeof dashboardPrescribersRoute
  '/(dashboard)/products': typeof dashboardProductsRoute
  '/(dashboard)/promotions': typeof dashboardPromotionsRoute
  '/(dashboard)/reports': typeof dashboardReportsRoute
  '/(dashboard)/sales': typeof dashboardSalesRoute
  '/(dashboard)/suppliers': typeof dashboardSuppliersRoute
  '/invite/$token': typeof InviteTokenRoute
  '/onboarding/consent': typeof OnboardingConsentRoute
  '/onboarding/create-branch': typeof OnboardingCreateBranchRoute
  '/onboarding/create-organization': typeof OnboardingCreateOrganizationRoute
  '/onboarding/invite-team': typeof OnboardingInviteTeamRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/(dashboard)/': typeof dashboardIndexRoute
  '/(dashboard)/account/security': typeof dashboardAccountSecurityRoute
  '/(dashboard)/branch/cash-drawers': typeof dashboardBranchCashDrawersRoute
  '/(dashboard)/branch/inventory': typeof dashboardBranchInventoryRoute
  '/(dashboard)/branch/prescriptions': typeof dashboardBranchPrescriptionsRoute
  '/(dashboard)/branch/rooms': typeof dashboardBranchRoomsRoute
  '/(dashboard)/branch/staff': typeof dashboardBranchStaffRoute
  '/(dashboard)/settings/api': typeof dashboardSettingsApiRoute
  '/(dashboard)/settings/billing': typeof dashboardSettingsBillingRoute
  '/(dashboard)/settings/branches': typeof dashboardSettingsBranchesRoute
  '/(dashboard)/settings/integrations': typeof dashboardSettingsIntegrationsRoute
  '/(dashboard)/settings/members': typeof dashboardSettingsMembersRoute
  '/(dashboard)/settings/organization': typeof dashboardSettingsOrganizationRoute
  '/(dashboard)/settings/printer': typeof dashboardSettingsPrinterRoute
  '/(dashboard)/settings/roles': typeof dashboardSettingsRolesRoute
  '/(dashboard)/account/': typeof dashboardAccountIndexRoute
  '/(dashboard)/branch/': typeof dashboardBranchIndexRoute
  '/(dashboard)/settings/': typeof dashboardSettingsIndexRoute
  '/(dashboard)/branch/settings/hours': typeof dashboardBranchSettingsHoursRoute
  '/(dashboard)/branch/settings/tax': typeof dashboardBranchSettingsTaxRoute
  '/(dashboard)/branch/settings/': typeof dashboardBranchSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/onboarding'
    | '/callback'
    | '/privacy'
    | '/analytics'
    | '/categories'
    | '/customers'
    | '/prescribers'
    | '/products'
    | '/promotions'
    | '/reports'
    | '/sales'
    | '/suppliers'
    | '/invite/$token'
    | '/onboarding/consent'
    | '/onboarding/create-branch'
    | '/onboarding/create-organization'
    | '/onboarding/invite-team'
    | '/onboarding/welcome'
    | '/'
    | '/account/security'
    | '/branch/cash-drawers'
    | '/branch/inventory'
    | '/branch/prescriptions'
    | '/branch/rooms'
    | '/branch/staff'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/branches'
    | '/settings/integrations'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/printer'
    | '/settings/roles'
    | '/account/'
    | '/branch/'
    | '/settings/'
    | '/branch/settings/hours'
    | '/branch/settings/tax'
    | '/branch/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/onboarding'
    | '/callback'
    | '/privacy'
    | '/analytics'
    | '/categories'
    | '/customers'
    | '/prescribers'
    | '/products'
    | '/promotions'
    | '/reports'
    | '/sales'
    | '/suppliers'
    | '/invite/$token'
    | '/onboarding/consent'
    | '/onboarding/create-branch'
    | '/onboarding/create-organization'
    | '/onboarding/invite-team'
    | '/onboarding/welcome'
    | '/'
    | '/account/security'
    | '/branch/cash-drawers'
    | '/branch/inventory'
    | '/branch/prescriptions'
    | '/branch/rooms'
    | '/branch/staff'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/branches'
    | '/settings/integrations'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/printer'
    | '/settings/roles'
    | '/account'
    | '/branch'
    | '/settings'
    | '/branch/settings/hours'
    | '/branch/settings/tax'
    | '/branch/settings'
  id:
    | '__root__'
    | '/(dashboard)'
    | '/onboarding'
    | '/callback'
    | '/privacy'
    | '/(dashboard)/analytics'
    | '/(dashboard)/categories'
    | '/(dashboard)/customers'
    | '/(dashboard)/prescribers'
    | '/(dashboard)/products'
    | '/(dashboard)/promotions'
    | '/(dashboard)/reports'
    | '/(dashboard)/sales'
    | '/(dashboard)/suppliers'
    | '/invite/$token'
    | '/onboarding/consent'
    | '/onboarding/create-branch'
    | '/onboarding/create-organization'
    | '/onboarding/invite-team'
    | '/onboarding/welcome'
    | '/(dashboard)/'
    | '/(dashboard)/account/security'
    | '/(dashboard)/branch/cash-drawers'
    | '/(dashboard)/branch/inventory'
    | '/(dashboard)/branch/prescriptions'
    | '/(dashboard)/branch/rooms'
    | '/(dashboard)/branch/staff'
    | '/(dashboard)/settings/api'
    | '/(dashboard)/settings/billing'
    | '/(dashboard)/settings/branches'
    | '/(dashboard)/settings/integrations'
    | '/(dashboard)/settings/members'
    | '/(dashboard)/settings/organization'
    | '/(dashboard)/settings/printer'
    | '/(dashboard)/settings/roles'
    | '/(dashboard)/account/'
    | '/(dashboard)/branch/'
    | '/(dashboard)/settings/'
    | '/(dashboard)/branch/settings/hours'
    | '/(dashboard)/branch/settings/tax'
    | '/(dashboard)/branch/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  dashboardRouteRoute: typeof dashboardRouteRouteWithChildren
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  PrivacyRoute: typeof PrivacyRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)': {
      id: '/(dashboard)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof dashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/': {
      id: '/(dashboard)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof dashboardIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/onboarding/welcome': {
      id: '/onboarding/welcome'
      path: '/welcome'
      fullPath: '/onboarding/welcome'
      preLoaderRoute: typeof OnboardingWelcomeRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/invite-team': {
      id: '/onboarding/invite-team'
      path: '/invite-team'
      fullPath: '/onboarding/invite-team'
      preLoaderRoute: typeof OnboardingInviteTeamRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/create-organization': {
      id: '/onboarding/create-organization'
      path: '/create-organization'
      fullPath: '/onboarding/create-organization'
      preLoaderRoute: typeof OnboardingCreateOrganizationRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/create-branch': {
      id: '/onboarding/create-branch'
      path: '/create-branch'
      fullPath: '/onboarding/create-branch'
      preLoaderRoute: typeof OnboardingCreateBranchRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/consent': {
      id: '/onboarding/consent'
      path: '/consent'
      fullPath: '/onboarding/consent'
      preLoaderRoute: typeof OnboardingConsentRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)/suppliers': {
      id: '/(dashboard)/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof dashboardSuppliersRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/sales': {
      id: '/(dashboard)/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof dashboardSalesRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/reports': {
      id: '/(dashboard)/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof dashboardReportsRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/promotions': {
      id: '/(dashboard)/promotions'
      path: '/promotions'
      fullPath: '/promotions'
      preLoaderRoute: typeof dashboardPromotionsRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/products': {
      id: '/(dashboard)/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof dashboardProductsRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/prescribers': {
      id: '/(dashboard)/prescribers'
      path: '/prescribers'
      fullPath: '/prescribers'
      preLoaderRoute: typeof dashboardPrescribersRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/customers': {
      id: '/(dashboard)/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof dashboardCustomersRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/categories': {
      id: '/(dashboard)/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof dashboardCategoriesRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/analytics': {
      id: '/(dashboard)/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof dashboardAnalyticsRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/settings/': {
      id: '/(dashboard)/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof dashboardSettingsIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/branch/': {
      id: '/(dashboard)/branch/'
      path: '/branch'
      fullPath: '/branch/'
      preLoaderRoute: typeof dashboardBranchIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/account/': {
      id: '/(dashboard)/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof dashboardAccountIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/settings/roles': {
      id: '/(dashboard)/settings/roles'
      path: '/settings/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof dashboardSettingsRolesRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/settings/printer': {
      id: '/(dashboard)/settings/printer'
      path: '/settings/printer'
      fullPath: '/settings/printer'
      preLoaderRoute: typeof dashboardSettingsPrinterRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/settings/organization': {
      id: '/(dashboard)/settings/organization'
      path: '/settings/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof dashboardSettingsOrganizationRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/settings/members': {
      id: '/(dashboard)/settings/members'
      path: '/settings/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof dashboardSettingsMembersRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/settings/integrations': {
      id: '/(dashboard)/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof dashboardSettingsIntegrationsRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/settings/branches': {
      id: '/(dashboard)/settings/branches'
      path: '/settings/branches'
      fullPath: '/settings/branches'
      preLoaderRoute: typeof dashboardSettingsBranchesRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/settings/billing': {
      id: '/(dashboard)/settings/billing'
      path: '/settings/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof dashboardSettingsBillingRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/settings/api': {
      id: '/(dashboard)/settings/api'
      path: '/settings/api'
      fullPath: '/settings/api'
      preLoaderRoute: typeof dashboardSettingsApiRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/branch/staff': {
      id: '/(dashboard)/branch/staff'
      path: '/branch/staff'
      fullPath: '/branch/staff'
      preLoaderRoute: typeof dashboardBranchStaffRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/branch/rooms': {
      id: '/(dashboard)/branch/rooms'
      path: '/branch/rooms'
      fullPath: '/branch/rooms'
      preLoaderRoute: typeof dashboardBranchRoomsRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/branch/prescriptions': {
      id: '/(dashboard)/branch/prescriptions'
      path: '/branch/prescriptions'
      fullPath: '/branch/prescriptions'
      preLoaderRoute: typeof dashboardBranchPrescriptionsRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/branch/inventory': {
      id: '/(dashboard)/branch/inventory'
      path: '/branch/inventory'
      fullPath: '/branch/inventory'
      preLoaderRoute: typeof dashboardBranchInventoryRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/branch/cash-drawers': {
      id: '/(dashboard)/branch/cash-drawers'
      path: '/branch/cash-drawers'
      fullPath: '/branch/cash-drawers'
      preLoaderRoute: typeof dashboardBranchCashDrawersRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/account/security': {
      id: '/(dashboard)/account/security'
      path: '/account/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof dashboardAccountSecurityRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/branch/settings/': {
      id: '/(dashboard)/branch/settings/'
      path: '/branch/settings'
      fullPath: '/branch/settings/'
      preLoaderRoute: typeof dashboardBranchSettingsIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/branch/settings/tax': {
      id: '/(dashboard)/branch/settings/tax'
      path: '/branch/settings/tax'
      fullPath: '/branch/settings/tax'
      preLoaderRoute: typeof dashboardBranchSettingsTaxRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/branch/settings/hours': {
      id: '/(dashboard)/branch/settings/hours'
      path: '/branch/settings/hours'
      fullPath: '/branch/settings/hours'
      preLoaderRoute: typeof dashboardBranchSettingsHoursRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
  }
}

interface dashboardRouteRouteChildren {
  dashboardAnalyticsRoute: typeof dashboardAnalyticsRoute
  dashboardCategoriesRoute: typeof dashboardCategoriesRoute
  dashboardCustomersRoute: typeof dashboardCustomersRoute
  dashboardPrescribersRoute: typeof dashboardPrescribersRoute
  dashboardProductsRoute: typeof dashboardProductsRoute
  dashboardPromotionsRoute: typeof dashboardPromotionsRoute
  dashboardReportsRoute: typeof dashboardReportsRoute
  dashboardSalesRoute: typeof dashboardSalesRoute
  dashboardSuppliersRoute: typeof dashboardSuppliersRoute
  dashboardIndexRoute: typeof dashboardIndexRoute
  dashboardAccountSecurityRoute: typeof dashboardAccountSecurityRoute
  dashboardBranchCashDrawersRoute: typeof dashboardBranchCashDrawersRoute
  dashboardBranchInventoryRoute: typeof dashboardBranchInventoryRoute
  dashboardBranchPrescriptionsRoute: typeof dashboardBranchPrescriptionsRoute
  dashboardBranchRoomsRoute: typeof dashboardBranchRoomsRoute
  dashboardBranchStaffRoute: typeof dashboardBranchStaffRoute
  dashboardSettingsApiRoute: typeof dashboardSettingsApiRoute
  dashboardSettingsBillingRoute: typeof dashboardSettingsBillingRoute
  dashboardSettingsBranchesRoute: typeof dashboardSettingsBranchesRoute
  dashboardSettingsIntegrationsRoute: typeof dashboardSettingsIntegrationsRoute
  dashboardSettingsMembersRoute: typeof dashboardSettingsMembersRoute
  dashboardSettingsOrganizationRoute: typeof dashboardSettingsOrganizationRoute
  dashboardSettingsPrinterRoute: typeof dashboardSettingsPrinterRoute
  dashboardSettingsRolesRoute: typeof dashboardSettingsRolesRoute
  dashboardAccountIndexRoute: typeof dashboardAccountIndexRoute
  dashboardBranchIndexRoute: typeof dashboardBranchIndexRoute
  dashboardSettingsIndexRoute: typeof dashboardSettingsIndexRoute
  dashboardBranchSettingsHoursRoute: typeof dashboardBranchSettingsHoursRoute
  dashboardBranchSettingsTaxRoute: typeof dashboardBranchSettingsTaxRoute
  dashboardBranchSettingsIndexRoute: typeof dashboardBranchSettingsIndexRoute
}

const dashboardRouteRouteChildren: dashboardRouteRouteChildren = {
  dashboardAnalyticsRoute: dashboardAnalyticsRoute,
  dashboardCategoriesRoute: dashboardCategoriesRoute,
  dashboardCustomersRoute: dashboardCustomersRoute,
  dashboardPrescribersRoute: dashboardPrescribersRoute,
  dashboardProductsRoute: dashboardProductsRoute,
  dashboardPromotionsRoute: dashboardPromotionsRoute,
  dashboardReportsRoute: dashboardReportsRoute,
  dashboardSalesRoute: dashboardSalesRoute,
  dashboardSuppliersRoute: dashboardSuppliersRoute,
  dashboardIndexRoute: dashboardIndexRoute,
  dashboardAccountSecurityRoute: dashboardAccountSecurityRoute,
  dashboardBranchCashDrawersRoute: dashboardBranchCashDrawersRoute,
  dashboardBranchInventoryRoute: dashboardBranchInventoryRoute,
  dashboardBranchPrescriptionsRoute: dashboardBranchPrescriptionsRoute,
  dashboardBranchRoomsRoute: dashboardBranchRoomsRoute,
  dashboardBranchStaffRoute: dashboardBranchStaffRoute,
  dashboardSettingsApiRoute: dashboardSettingsApiRoute,
  dashboardSettingsBillingRoute: dashboardSettingsBillingRoute,
  dashboardSettingsBranchesRoute: dashboardSettingsBranchesRoute,
  dashboardSettingsIntegrationsRoute: dashboardSettingsIntegrationsRoute,
  dashboardSettingsMembersRoute: dashboardSettingsMembersRoute,
  dashboardSettingsOrganizationRoute: dashboardSettingsOrganizationRoute,
  dashboardSettingsPrinterRoute: dashboardSettingsPrinterRoute,
  dashboardSettingsRolesRoute: dashboardSettingsRolesRoute,
  dashboardAccountIndexRoute: dashboardAccountIndexRoute,
  dashboardBranchIndexRoute: dashboardBranchIndexRoute,
  dashboardSettingsIndexRoute: dashboardSettingsIndexRoute,
  dashboardBranchSettingsHoursRoute: dashboardBranchSettingsHoursRoute,
  dashboardBranchSettingsTaxRoute: dashboardBranchSettingsTaxRoute,
  dashboardBranchSettingsIndexRoute: dashboardBranchSettingsIndexRoute,
}

const dashboardRouteRouteWithChildren = dashboardRouteRoute._addFileChildren(
  dashboardRouteRouteChildren,
)

interface OnboardingRouteRouteChildren {
  OnboardingConsentRoute: typeof OnboardingConsentRoute
  OnboardingCreateBranchRoute: typeof OnboardingCreateBranchRoute
  OnboardingCreateOrganizationRoute: typeof OnboardingCreateOrganizationRoute
  OnboardingInviteTeamRoute: typeof OnboardingInviteTeamRoute
  OnboardingWelcomeRoute: typeof OnboardingWelcomeRoute
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingConsentRoute: OnboardingConsentRoute,
  OnboardingCreateBranchRoute: OnboardingCreateBranchRoute,
  OnboardingCreateOrganizationRoute: OnboardingCreateOrganizationRoute,
  OnboardingInviteTeamRoute: OnboardingInviteTeamRoute,
  OnboardingWelcomeRoute: OnboardingWelcomeRoute,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  dashboardRouteRoute: dashboardRouteRouteWithChildren,
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  CallbackRoute: CallbackRoute,
  PrivacyRoute: PrivacyRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
